import React from "react";
import {
  Grid,
  Button,
  Typography,
  CircularProgress,
  Box
} from "@mui/material";

const UploadInventory = ({
  file,
  setFile,
  onUpload,
  loading,
}) => {

  const handleFileChange = (event) => {

    if (!event.target.files.length) return;

    const selected = event.target.files[0];

    const extension = selected.name
      .split(".")
      .pop()
      .toLowerCase();

    if (
      extension !== "xlsx" &&
      extension !== "xls" &&
      extension !== "csv"
    ) {
      alert("Only Excel and CSV files are allowed.");
      return;
    }

    setFile(selected);
  };

  return (
   <Box
  display="flex"
  alignItems="center"
  gap={2}
>
  <Button variant="outlined" component="label">
    Choose File
    <input
      hidden
      type="file"
      accept=".xlsx,.xls,.csv"
      onChange={handleFileChange}
    />
  </Button>

  <Typography
    sx={{
      minWidth: 220,
    }}
  >
    {file ? file.name : "No file selected"}
  </Typography>

  <Button
    variant="contained"
    onClick={onUpload}
    disabled={loading}
  >
    {loading ? (
      <CircularProgress
        size={22}
        color="inherit"
      />
    ) : (
      "Upload"
    )}
  </Button>
</Box>
  );
};

export default UploadInventory;